document.addEventListener('DOMContentLoaded', () => {
  const headerLogos = document.querySelectorAll('.header-logo');

  if (headerLogos.length > 0) {
    // Check if device is mobile
    const isMobile = () => window.innerWidth <= 749;

    // Set initial fixed shadow for mobile logos
    const setMobileShadow = (logo) => {
      const shadowDirection = logo.getAttribute('data-shadow-direction');
      if (shadowDirection === 'top') {
        // Detect background brightness to set appropriate shadow color
        const bgColor = getComputedStyle(document.body).getPropertyValue('--color-background').trim() || 'rgb(255, 255, 255)';
        const getBrightness = (color) => {
          let r = 255, g = 255, b = 255;
          if (color.startsWith('#')) {
            const hex = color.substring(1);
            if (hex.length === 3) {
               r = parseInt(hex[0] + hex[0], 16);
               g = parseInt(hex[1] + hex[1], 16);
               b = parseInt(hex[2] + hex[2], 16);
            } else {
               r = parseInt(hex.substring(0, 2), 16);
               g = parseInt(hex.substring(2, 4), 16);
               b = parseInt(hex.substring(4, 6), 16);
            }
          } else if (color.startsWith('rgb')) {
            const rgb = color.match(/\d+/g);
            if (rgb) {
              r = parseInt(rgb[0]);
              g = parseInt(rgb[1]);
              b = parseInt(rgb[2]);
            }
          }
          return (r * 299 + g * 587 + b * 114) / 1000;
        };
        const brightness = getBrightness(bgColor);
        const shadowColor = brightness > 200 ? 'rgb(0, 0, 0)' : 'rgb(255, 255, 255)';
        logo.style.textShadow = `2px -2px 0px ${shadowColor}`;
      }
    };

    // Initialize mobile shadows
    if (isMobile()) {
      headerLogos.forEach(logo => {
        if (logo.getAttribute('data-shadow-direction') === 'top') {
          setMobileShadow(logo);
        }
      });
    }

    // Use 'window' to track mouse movement across the entire viewport
    window.addEventListener('mousemove', (e) => {
      // Disable on mobile
      if (isMobile()) return;
      if (typeof gsap === 'undefined') return;

      headerLogos.forEach(headerLogo => {
        const rect = headerLogo.getBoundingClientRect();
        // Calculate position relative to the center of the logo
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;

        // Calculate shadow offset based on distance from center
        // Invert direction (-1) to make it look like a shadow cast by a moving light source
        // Multiplier 15 for moderate movement
        let shadowX = -1 * (x / window.innerWidth) * 15;
        
        // Shadow Y offset - default to bottom (2), or top (-2) if specified
        const shadowDirection = headerLogo.getAttribute('data-shadow-direction');
        let shadowY = (y / window.innerHeight) * 15;
        
        // Cap the maximum shadow distance to prevent extreme movement on large screens
        const maxDistance = 1.8; // Maximum pixels the shadow can move
        const minDistance = 1; // Minimum offset to prevent centering
        
        shadowX = Math.max(-maxDistance, Math.min(maxDistance, shadowX));
        shadowY = Math.max(-maxDistance, Math.min(maxDistance, shadowY));

        // Ensure shadow never centers horizontally - always has minimum offset
        if (Math.abs(shadowX) < minDistance) {
          shadowX = shadowX >= 0 ? minDistance : -minDistance;
        }
        
        // Ensure shadow never centers vertically
        if (Math.abs(shadowY) < minDistance) {
          shadowY = shadowY >= 0 ? minDistance : -minDistance;
        }

        // Determine current background color to ensure shadow contrasts
        // If background is dark, shadow should be white. If background is light, shadow should be dark.
        const bgColor = getComputedStyle(document.body).getPropertyValue('--color-background').trim() || 'rgb(255, 255, 255)';
        
        // Helper to convert rgb/hex to brightness (0-255)
        const getBrightness = (color) => {
          let r = 255, g = 255, b = 255;
          if (color.startsWith('#')) {
            const hex = color.substring(1);
            if (hex.length === 3) {
               r = parseInt(hex[0] + hex[0], 16);
               g = parseInt(hex[1] + hex[1], 16);
               b = parseInt(hex[2] + hex[2], 16);
            } else {
               r = parseInt(hex.substring(0, 2), 16);
               g = parseInt(hex.substring(2, 4), 16);
               b = parseInt(hex.substring(4, 6), 16);
            }
          } else if (color.startsWith('rgb')) {
            const rgb = color.match(/\d+/g);
            if (rgb) {
              r = parseInt(rgb[0]);
              g = parseInt(rgb[1]);
              b = parseInt(rgb[2]);
            }
          }
          return (r * 299 + g * 587 + b * 114) / 1000;
        };

        const brightness = getBrightness(bgColor);
        // If background is light (brightness > 200), use solid black shadow. Otherwise use white.
        const shadowColor = brightness > 200 ? 'rgb(0, 0, 0)' : 'rgb(255, 255, 255)';

        gsap.to(headerLogo, {
          textShadow: `${shadowX}px ${shadowY}px 0px ${shadowColor}`,
          duration: 0.3,
          ease: 'power2.out',
        });
      });
    });
  }
});
